import config from '../../config/physics.v1.json';
import lookup from '../../config/trig.v1.json';
import type { Hook, Mineral } from '../types.js';
export const PHYSICS = Object.freeze({ ...config, radii: Object.freeze(config.radii), progress: Object.freeze(config.progress), returnSpeeds: Object.freeze(config.returnSpeeds) });
export const physics = PHYSICS;
export const PHYSICS_VERSION = PHYSICS.version;
export const SCALE = PHYSICS.scale;
export const TICK_RATE = PHYSICS.tickRate;
export const A_TICKS = PHYSICS.aTicks;
export const B_TICKS = PHYSICS.bTicks;
/** Integer LUT lookup rounded to nearest 0.1 degree; no runtime trigonometry. */
export function directionAt(angle: number): { x: number; y: number } {
  if (!Number.isSafeInteger(angle) || angle < PHYSICS.minAngle || angle > PHYSICS.maxAngle) throw new Error('Invalid angle');
  const index = Math.round((angle - PHYSICS.minAngle) / PHYSICS.trigStepMilliDegrees);
  return { x: lookup.sin[index]!, y: lookup.cos[index]! };
}
export function positionAt(angle: number, distance: number): { x: number; y: number } {
  const direction = directionAt(angle);
  return { x: PHYSICS.originX + Math.trunc(direction.x * distance / PHYSICS.trigScale), y: PHYSICS.originY + Math.trunc(direction.y * distance / PHYSICS.trigScale) };
}
export function collisionAt(hook: Pick<Hook, 'x' | 'y'>, objects: readonly Mineral[]): Mineral | undefined {
  for (const object of [...objects].sort((a, b) => a.id - b.id)) {
    const dx = hook.x - object.x;
    const dy = hook.y - object.y;
    if (dx * dx + dy * dy <= object.radius * object.radius) return object;
  }
  return undefined;
}
export function newHook(): Hook {
  return { status: 'SWINGING', angle: PHYSICS.initialAngle, direction: 1, distance: 0, x: PHYSICS.originX, y: PHYSICS.originY, carry: null, shotPhase: null, fastReturn: false };
}
